import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { travelEnforcementList } from '@/module/Travel/Settings/model/TravelSettingsTypes';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type TravelEnforcementSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function TravelEnforcementSelectControl<T extends FieldValues>(props: TravelEnforcementSelectControlProps<T>) {
  const { t } = useTranslation();
  const options = useMemo(
    () => travelEnforcementList.map(value => ({ value, label: t(`travel.enforcementEnum.${value}`) })),
    [t],
  );

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
